<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>FAQ</h4>
    </div>
  </div>
  <mat-card>
    <p>
      <a href="faq#FuerWen"
        >Für wen und welchen Anlass wurde die Web-Anwendung erstellt?</a
      >
    </p>
    <p>
      <a href="faq#WelcheKriterien"
        >Nach welchen Kriterien wurden die Indikatoren ausgewählt?</a
      >
    </p>
    <p>
      <a href="faq#WarumMehrfach"
        >Warum sind manche Indikatoren in der Ergebnisliste mehrfach
        aufgeführt?</a
      >
    </p>
    <p>
      <a href="faq#WievieleIndikatoren"
        >Wie viele Indikatoren sind in der Datenbank enthalten?</a
      >
    </p>
    <p>
      <a href="faq#GesondertGelistet"
        >Was sind Tierwohl-Begleitindikatoren und warum werden sie gesondert
        gelistet?
      </a>
    </p>

    <p>
      <a href="faq#WasSindTierResIndi"
        >Was sind tier-, ressourcen- und managementbezogene Indikatoren?
      </a>
    </p>
    <p>
      <a href="faq#WasSindTierDimen">Was sind die Tierwohl-Dimensionen? </a>
    </p>

    <p>
      <a href="faq#WerEntwicklungBeteiltigt"
        >Wer war an der Entwicklung der Web-Anwendung beteiligt?</a
      >
    </p>

    <p>
      <a href="faq#WieUnterscheidet"
        >Inwiefern unterscheiden sich die Indikatoren dieser Datenbank von den
        Tierschutzindikatoren anderer Projekte, z.B. EiKoTiGer (Eigenkontrolle
        Tiergerechtheit?)
      </a>
    </p>

    <p>
      <a href="faq#MitWasNutzbar"
        >Mit welchen Geräten ist die Anwendung nutzbar?
      </a>
    </p>

    <p>
      <a href="faq#WieAktuell">Wie aktuell ist die Anwendung? </a>
    </p>

    <br />
    <h5>
      <a name="FuerWen">
        Für wen und welchen Anlass wurde die Web-Anwendung erstellt?</a
      >
    </h5>
    Die Web-Anwendung dient der Literaturrecherche zu Tierwohlindikatoren. Sie
    bietet Wissenschaftlerinnen und Wissenschaftlern und allen, die
    wissenschaftliche Indikatoren entwickeln oder einsetzen wollen, eine
    systematische Übersicht über den Stand des Wissens aus deutscher und
    internationaler Literatur. Es erfolgt keine Bewertung der Indikatoren. Alle
    Informationen zu den Indikatoren können als Steckbrief angezeigt und
    heruntergeladen werden. Die Informationen wurden im Rahmen der
    Literaturrecherche des Projektes
    <a href="https://www.nationales-tierwohl-monitoring.de/"
      >„Nationales Tierwohl-Monitoring“ (NaTiMon)</a
    >
    zusammengetragen.
    <br />
    <br />
    <h5>
      <a name="WelcheKriterien">
        Nach welchen Kriterien wurden die Indikatoren ausgewählt?</a
      >
    </h5>

    Es wurden Indikatoren aufgenommen, die eine valide Aussage über das Tierwohl
    treffen können. Indikatoren, die für das Projekt NaTiMon grundsätzlich als
    nicht geeignet eingeschätzt wurden, z.B. aufgrund invasiver
    Erhebungsmethoden, oder einem zu hohen Erhebungsaufwand, z.B. Erfassungen
    über Sensoren, sind nicht in der Datenbank enthalten.
    <br />
    <br />
    <h5>
      <a name="WarumMehrfach"
        >Warum sind manche Indikatoren in der Ergebnisliste mehrfach
        aufgeführt?</a
      >
    </h5>
    Manche Indikatoren werden übergreifend zu Tierarten bzw. Tierkategorien
    verwendet und können daher mehrfach aufgeführt sein, z.B. der Indikator
    „Mortalität“. Ob es sich um völlig identische oder nur namensidentische
    Indikatoren handelt, ist an ihrer Identifikationsnummer oder der Quelle zu
    erkennen. Unterschiedliche Nummern weisen darauf hin, dass es z.B.
    methodische Unterschiede in der Erhebung geben kann. Mithilfe der
    Schaltfläche „Zeige doppelte Einträge in Tabelle“ können Sie
    Mehrfachnennungen ein- und ausblenden.
    <br />
    <br />
    <h5>
      <a name="WievieleIndikatoren"
        >Wie viele Indikatoren sind in der Datenbank enthalten?</a
      >
    </h5>

    In der Datenbank sind ca. 2.500 Indikatoren enthalten. Viele Indikatoren
    gelten jedoch gleichzeitig für mehrere Tierarten oder Nutzungsrichtungen,
    sodass insgesamt mehr als 5.000 Indikatoren angezeigt werden können (siehe
    auch „Warum sind Indikatoren in der Ergebnisliste mehrfach aufgeführt?“).

    <br />
    <br />
    <h5>
      <a name="GesondertGelistet"
        >Was sind Tierwohl-Begleitindikatoren und warum werden sie gesondert
        gelistet?</a
      >
    </h5>
    Tierwohl-Begleitindikatoren bilden das Tierwohl nicht direkt ab. Sie können
    einerseits Hinweise auf das Engagement des Staates im Bereich des Tierwohls
    geben, sie adressieren aber auch die Bestrebungen der Konsumentinnen und
    Konsumenten sowie der Produzentinnen und Produzenten, das Tierwohl zu
    verbessern. Die Tierwohl-Begleitindikatoren beziehen sich auf die
    allgemeinen Rahmenbedingungen zum Tierwohl, nicht auf einzelne Tierarten.
    Tierwohlindikatoren, wie z.B. Mortalität, können unmittelbar einen Hinweis
    auf das Wohl der Tiere geben – die Tierwohl-Begleitindikatoren beschreiben
    hingegen rechtliche, sozioökonomische oder strukturelle Bedingungen, die
    indirekt Schlüsse auf die nationale Tierwohlsituation ermöglichen. Beispiele
    sind das Konsumverhalten der Gesellschaft, der Anteil an Tieren in
    Tierwohl-Fördermaßnahmen oder die Anzahl amtlicher Tierschutzkontrollen.

    <br />
    <br />
    <h5>
      <a name="WasSindTierResIndi"
        >Was sind tier-, ressourcen- und managementbezogene Indikatoren?</a
      >
    </h5>
    Tierbezogene Indikatoren beschreiben das Tierwohl direkt am Tier. Sie
    erlauben direkte Rückschlüsse, z.B. wie Haltung und Management auf das
    Tierwohl wirken. Ressourcen- und managementbezogene Indikatoren erfassen
    baulich-technische Gegebenheiten von Haltungsbedingungen, z.B. das
    Platzangebot, sowie das Management, z.B. die Fütterung oder Eingriffe am
    Tier. Ressourcen- und managementbezogene Indikatoren beziehen sich also auf
    die Voraussetzungen für das Tierwohl und lassen indirekte Rückschlüsse zu,
    wie es den Tieren unter diesen Bedingungen geht; das Tierwohl ist nicht
    direkt nachweisbar.
    <br />
    <br />

    <h5>
      <a name="WasSindTierDimen">Was sind die Tierwohl-Dimensionen?</a>
    </h5>
    Die Tierwohl-Dimensionen sind körperliche Gesundheit, Verhalten und
    Emotionen. In ihrer Kombination beschreiben sie das Tierwohl ganzheitlich.
    <br />
    <br />
    <h5>
      <a name="WerEntwicklungBeteiltigt"
        >Wer war an der Entwicklung der Web-Anwendung beteiligt?</a
      >
    </h5>
    Die Inhalte zu den Indikatoren (siehe Steckbriefe) wurden von den
    Projektpartnerinnen und Projektpartnern des Projektes „Nationales
    Tierwohl-Monitoring“ (NaTiMon) zusammengestellt. Die Web-Anwendung wurde vom
    KTBL konzipiert und programmiert.
    <br />
    <br />
    <h5>
      <a name="WieUnterscheidet"
        >Inwiefern unterscheiden sich die Indikatoren dieser Datenbank von den
        Tierschutzindikatoren anderer Projekte, z.B. EiKoTiGer (Eigenkontrolle
        Tiergerechtheit)?</a
      >
    </h5>

    Dies ist eine Literaturdatenbank, in der die Ergebnisse der
    Literaturrecherche des Projektes NaTiMon veröffentlicht sind. Für NaTiMon
    wurden v.a. die in der wissenschaftlichen Literatur veröffentlichten
    Indikatoren gesichtet und zusammengestellt, darunter auch die in EiKoTiGer
    beschriebenen Indikatoren. In NaTiMon werden in weiteren auf die
    Literaturrecherche folgenden Schritten die Indikatoren ausgewählt, mit denen
    sich das Tierwohl auf nationaler Ebene beschreiben lässt.
    <br />
    <br />
    <h5>
      <a name="MitWasNutzbar">Mit welchen Geräten ist die Anwendung nutzbar?</a>
    </h5>

    Die Anwendung ist für die Nutzung mit Desktop-PC optimiert.
    <br />
    <br />
    <h5>
      <a name="WieAktuell">Wie aktuell ist die Anwendung?</a>
    </h5>

    Die Anwendung wurde 2021 erarbeitet. Die jüngste Literatur stammt aus 2021.
    Indikatoren, zu denen keine neuen Quellen bekannt sind bzw. deren Inhalte
    sich nicht geändert haben und somit weiterhin aktuell sind, können sich
    daher auf ältere Literatur beziehen.

    <h5></h5>
    <!--Wegen Formatierung drinnen, nicht wegnehmen sonst ist bei  am Ende ein Abstand nicht drinnen-->
  </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon [icon]="faArrowLeft" class="mx-1 icon-arrow"></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
